import React from 'react';
import { Form, Input, Select, DatePicker } from 'antd';
import { theme } from '../../../theme';
import dayjs from 'dayjs';

const { Option } = Select;

interface Producto {
  id: number;
  tipo: number;
  descripcion: string;
}

interface DatosBasicosContratoProps {
  productos: Producto[];
  formData: {
    ncontrato: string;
    tipo: 'C' | 'V' | '';
    producto_id: number;
    fecha: string;
  };
  onFieldChange: (field: string, value: any) => void;
}

export const DatosBasicosContrato: React.FC<DatosBasicosContratoProps> = ({
  productos,
  formData,
  onFieldChange
}) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '16px' }}>
      <Form.Item
        label={<span style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>Nº Contrato</span>}
        required
        style={{ marginBottom: 0 }}
      >
        <Input
          placeholder="Ej: CON-2024-001"
          value={formData.ncontrato}
          onChange={(e) => onFieldChange('ncontrato', e.target.value)}
          size="small"
        />
      </Form.Item>

      <Form.Item
        label={<span style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>Tipo</span>}
        required
        style={{ marginBottom: 0 }}
      >
        <Select
          placeholder="Seleccionar tipo"
          value={formData.tipo || undefined}
          onChange={(value) => onFieldChange('tipo', value)}
          size="small"
        >
          <Option value="C">Compra</Option>
          <Option value="V">Venta</Option>
        </Select>
      </Form.Item>

      <Form.Item
        label={<span style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>Producto</span>}
        required
        style={{ marginBottom: 0 }}
      >
        <Select
          placeholder="Seleccionar producto"
          value={formData.producto_id || undefined}
          onChange={(value) => onFieldChange('producto_id', value)}
          size="small"
        >
          {productos.filter(producto => producto.tipo !== 1).map((producto) => (
            <Option key={producto.id} value={producto.id}>
              {producto.descripcion}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        label={<span style={{ color: theme.colors.textPrimary, fontWeight: 500 }}>Fecha</span>}
        style={{ marginBottom: 0 }}
      >
        <DatePicker
          style={{ width: '100%' }}
          format="DD/MM/YYYY"
          value={formData.fecha ? dayjs(formData.fecha) : null}
          onChange={(date) => onFieldChange('fecha', date ? date.format('YYYY-MM-DD') : '')}
          size="small"
          placeholder="Seleccionar fecha"
        />
      </Form.Item>
    </div>
  );
};

